import {useSelector} from "react-redux";
import TaskComment from "./task-comment";
import {
    normalizeMembershipEntity,
    prepareMembershipPayload,
} from "../workspace-membership/workspace-membership-identity";

const commentPopulate = {
    children: {
        populate: {
            user: {populate: {member: {populate: "profileImage"}}},
        },
    },
    user: {populate: {member: {populate: "profileImage"}}},
    attachments: true,
};

export function useTaskComment() {
    const workspaceMembership = useSelector((state) => state.app?.workspaceMembershipData);
    const memberships = workspaceMembership?.workspace?.workspace_memberships || [];

    const normalizeComment = (item) => {
        const normalized = normalizeMembershipEntity(item, "taskComment", memberships);
        if (!normalized) return normalized;
        normalized.children = (normalized.children || []).map((child) =>
            normalizeMembershipEntity(child, "taskComment", memberships));
        return normalized;
    };

    const getTaskComments = async (taskId)=>{
        try {
            const taskComment = new TaskComment();
            const query = {
                filters: {
                    $and:[
                        {task:{$eq: taskId}},
                    ],
                },
                populate: commentPopulate,
            }
            const _data = await taskComment.getAll(query);

            return (_data.data || []).map(normalizeComment)
        }catch (e){
            throw e;
        }
    }

    const updateTaskComment = async (commentId, commentData)=>{
        try {
            const taskComment = new TaskComment();
            const payload = prepareMembershipPayload("taskComment", commentData, memberships, {
                currentMembership: workspaceMembership,
                operation: "update",
            });
            const _data = await taskComment.update(commentId, payload, {populate: commentPopulate});
            return normalizeComment(_data.data)
        }catch (e){
            throw e;
        }
    }

    const createTaskComment = async (commentData)=>{
        try {
            const taskComment = new TaskComment();
            const query = {populate: commentPopulate};
            const payload = prepareMembershipPayload("taskComment", commentData, memberships, {
                currentMembership: workspaceMembership,
                operation: "create",
            });
            const _data = await taskComment.create(payload, query);
            return normalizeComment(_data.data)
        }catch (e){
            throw e;
        }
    }

    const deleteTaskComment = async (commentId) => {
        const taskComment = new TaskComment();
        return taskComment.delete(commentId);
    };




    return {getTaskComments, updateTaskComment, createTaskComment, deleteTaskComment};
}
